import React, { ReactElement, useEffect, useMemo } from 'react';
import { Form } from 'formik';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import { DataCollectionValues } from '../../../../../types';
import FormControl from '../../../../components/Form/FormControl';
import StepHeader from '../../../../components/Layout/StepHeader';
import InfoCard from '../../../../components/Layout/InfoCard';
import { TextsStepTotalAreaOfEvaluatedBuildingCoverPENB } from '../../../../../data/dictionary';

interface FormError {
    totalAreaOfBuildingEnvelope?: string;
}

const stepValidation = (values: DataCollectionValues) => {
    const errors: FormError = {};

    if (!values.totalAreaOfBuildingEnvelope || Number(values.totalAreaOfBuildingEnvelope) < 0) {
        errors.totalAreaOfBuildingEnvelope = 'Povinné pole';
    }

    return errors;
};

const StepTotalAreaOfEvaluatedBuildingCoverPENB = ({
    completeStep,
}: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    const errors = useMemo(() => stepValidation(values), [values]);
    useEffect(() => {
        completeStep && completeStep(!Object.keys(errors).length);
    }, [errors]);

    return (
        <Form>
            <StepHeader
                title="Celková plocha hodnocené obálky budovy"
                subtitle="Vyplňte prosím hodnotu z průkazu Vaší budovy"
            />
            <InfoCard img="plocha-obalky.jpg" texts={TextsStepTotalAreaOfEvaluatedBuildingCoverPENB} />
            <div className="otz-house-info otz-house-info-small">
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Celková plocha obálky budovy</div>
                        <div className="otz-house-info__select">
                            <div className="form-container form-container--text">
                                <FormControl
                                    name="totalAreaOfBuildingEnvelope"
                                    id="totalAreaOfBuildingEnvelope"
                                    type="number"
                                    tag="input"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.totalAreaOfBuildingEnvelope}
                                    error={errors.totalAreaOfBuildingEnvelope}
                                />
                                <div className="wiz-form-text">
                                    m<sup>2</sup>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepTotalAreaOfEvaluatedBuildingCoverPENB;
